/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const customerLifecycleResponseOutputIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const customerLifecycleResponseOutputVersionExclusiveMin = 0;
export const customerLifecycleResponseOutputVersionMax = 9007199254740991;

export const customerLifecycleResponseOutputCreatedAtRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const customerLifecycleResponseOutputUpdatedAtRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const customerLifecycleResponseOutputArchivedAtOneRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const customerLifecycleResponseOutputAssignmentCountMin = 0;
export const customerLifecycleResponseOutputAssignmentCountMax = 9007199254740991;

export const customerLifecycleResponseOutputKnownNumberCountMin = 0;
export const customerLifecycleResponseOutputKnownNumberCountMax = 9007199254740991;

export const CustomerLifecycleResponseOutput = zod.object({
  id: zod.uuid().regex(customerLifecycleResponseOutputIdRegExp),
  name: zod.string(),
  status: zod.enum(['active', 'archived']),
  version: zod
    .int()
    .gt(customerLifecycleResponseOutputVersionExclusiveMin)
    .max(customerLifecycleResponseOutputVersionMax),
  createdAt: zod.iso
    .datetime({ offset: true })
    .regex(customerLifecycleResponseOutputCreatedAtRegExp),
  updatedAt: zod.iso
    .datetime({ offset: true })
    .regex(customerLifecycleResponseOutputUpdatedAtRegExp),
  archivedAt: zod.union([
    zod.iso.datetime({ offset: true }).regex(customerLifecycleResponseOutputArchivedAtOneRegExp),
    zod.null(),
  ]),
  assignmentCount: zod
    .int()
    .min(customerLifecycleResponseOutputAssignmentCountMin)
    .max(customerLifecycleResponseOutputAssignmentCountMax),
  knownNumberCount: zod
    .int()
    .min(customerLifecycleResponseOutputKnownNumberCountMin)
    .max(customerLifecycleResponseOutputKnownNumberCountMax),
});

export type CustomerLifecycleResponseOutput = zod.input<typeof CustomerLifecycleResponseOutput>;
export type CustomerLifecycleResponseOutputOutput = zod.output<
  typeof CustomerLifecycleResponseOutput
>;
